const baseURL = '/api'

export default baseURL